const messages: Record<string, string> = {
	'loader.loading': 'Loading data ...',
	'loader.error': 'Your process could not be loaded. Please try again later...',
	'connectionError.title': 'Connection error',
	'connectionError.description': 'Connection error. Please upload picture again.',
	'mainError.tryAgain': 'Try again',
	'landing.headline.policyCheck': 'Welcome',
	'landing.paragraph': 'You are three steps away from finishing the process',
	'landing.stepDescription.fourAdditionalPictures': 'Take the required pictures',
	'landing.stepDescription.fourDiagonalPerspectives': 'Upload pictures',
	'landing.stepDescription.feedback': 'Give us your feedback',

	termsAndConditionsLinkDescription: '0',
	termsAndConditionsLink: 'Accept the terms and conditions',
	'button.start': 'Start',
	'landing.aboutPolicyCheck': 'What is PolicyCheck?',
	'landing.additional-informations-section.title':
		'Before starting the inspection of your vehicle, check that:',

	'landing.additional-informations-section.text':
		'<ul><li>You have the keys and the registration certificate at hand</li><li>You are in a place with good light and mobile network</li><li>The vehicle is accessible from all angles and all side windows are closed </li></ul>',
	'landing.additional-informations-section.text.motorbike': ' ',
	'chooseLang.headline': 'Choose your preferred language',
	'button.close': 'Close',
	'blockedByDevice.headline': 'PolicyCheck does not support desktop browsers',

	'blockedByDevice.description':
		'PolicyCheck is using a desktop browser.\r\nThe PolicyCheck platform performs documenting cases using mobile devices.\r\nTo continue, please run the PolicyCheck link on a mobile device.',

	'vehicleImages.overviewPhotos': 'Vehicle overview photos',
	'vehicleImages.overviewPhotos.subtitle': 'Take the vehicle photo',
	'vehicleImages.description':
		'Take your vehicle photos diagonally front left and right, rear left and right. The license plate must be visible in all pictures.',
	'vehicleImages.description.motorbike': ' ',
	'fourDiagonalPerspectives.vehicleFrontLeft.title': 'Photo of the front left diagonal',
	'fourDiagonalPerspectives.vehicleRearLeft.title': 'Photo of the rear left diagonal',
	'fourDiagonalPerspectives.vehicleRearRight.title': 'Photo of the rear right diagonal',
	'fourDiagonalPerspectives.vehicleFrontRight.title': 'Photo of the front right diagonal',
	'button.next': 'Next',
	'imageRecognitionFeedback2.exemplaryPhoto': 'Exemplary photo',
	'imageRecognitionMismatchModal.headline': 'Are you sure you added the right photo ?',
	'button.continue': 'Continue',
	'button.backchangeImage': 'Back & change image',
	'completeVehicleImagesModal.headline': 'Help',
	'completeVehicleImagesModal.description': 'Please add the following information',
	'completeVehicleImagesModal.hasVehicleImageFrontLeft': 'Photo of the vehicle front left',
	'completeVehicleImagesModal.hasVehicleImageRearLeft': 'Photo of the vehicle back left',
	'completeVehicleImagesModal.hasVehicleImageFrontRight': 'Photo of the vehicle front right',
	'completeVehicleImagesModal.hasVehicleImageRearRight': 'Photo of the vehicle back right',
	'vehicleImages.leftFrontOverview': 'Diagonal photo of the front - left side',
	'vehicleImages.leftRearOverview': 'Diagonal photo of the rear - left side',
	'vehicleImages.rightRearOverview': 'Diagonal photo of the rear - right side',
	'vehicleImages.rightFrontOverview': 'Diagonal photo of the front - right side',
	'button.changeImage': 'Change the photo',
	'button.deleteImage': 'Delete the photo',
	'fourDiagonalPerspectives.vehicleFrontLeft.exampleModalTitle':
		'Exemplary photo - Photo of the vehicle front left',
	'fourDiagonalPerspectives.vehicleRearLeft.exampleModalTitle':
		'Exemplary photo - Photo of the vehicle back left',
	'fourDiagonalPerspectives.vehicleRearRight.exampleModalTitle':
		'Exemplary photo - Photo of the vehicle back right',
	'fourDiagonalPerspectives.vehicleFrontRight.exampleModalTitle':
		'Exemplary photo - Photo of the vehicle front right',

	'fourAdditionalPictures.title': 'Additional pictures',
	'fourAdditionalPictures.overallDashboard.title': "Vehicle's dashboard",
	'fourAdditionalPictures.overallDashboard.description':
		"Photograph your vehicle's dashboard completely.",
	'fourAdditionalPictures.mileage.title': 'Odometer',
	'fourAdditionalPictures.mileage.description':
		'Please take a photo of your mileage. If your vehicle has a digital display, please switch it on.',
	'fourAdditionalPictures.mileage.enter': "Enter the vehicle's mileage",
	'dashboardMileage.placeholder': 'for example 150000 km',
	'fourAdditionalPictures.windshield.title': "Vehicle's front windshield",
	'fourAdditionalPictures.windshield.description':
		"Please take a detailed photo of your vehicle's front windshield",
	'fourAdditionalPictures.vin.title': "Vehicle's VIN number",
	'fourAdditionalPictures.vin.description':
		"Please take a photo of your vehicle's VIN number. You could find this on the driver's door seal or the bottom left corner of the windshield.",
	'overallDashboardImage.title': 'Overall dashboard image',
	'dashboardMileage.dashboard.title': 'Photo of the mileage',
	'windshieldImage.title': 'Windshield photo',
	'vinPicture.title': 'Photo of the VIN number',
	'completeFourAdditionalPicturesModal.headline': 'Help',
	'completeFourAdditionalPicturesModal.description': 'Please add the following information',
	'completeFourAdditionalPicturesModal.hasOverallDashboardImage':
		'Photo of the vehicle´s dashboard',
	'completeFourAdditionalPicturesModal.hasMileageImage': 'Photo of the mileage',
	'completeDashboardMileageModal.hasValidMileage': 'The vehicle mileage',
	'completeFourAdditionalPicturesModal.hasVINImage': 'Photo of the vehicle´s VIN number',
	'completeFourAdditionalPicturesModal.hasWindshieldImage':
		'Photo of the vehicle´s front windshield',
	'fourAdditionalPictures.overallDashboard.exampleModalTitle':
		'Exemplary photo - Photo of the vehicle´s dashboard',
	'fourAdditionalPictures.dashboard.exampleModalTitle': 'Exemplary photo - Photo of the mileage',
	'fourAdditionalPictures.windshield.exampleModalTitle':
		'Exemplary photo - Photo of the vehicle´s front windshield',
	'fourAdditionalPictures.vin.exampleModalTitle': 'Exemplary photo - Photo of the VIN number',
	'fourAdditionalPicturesExampleModal.button.close': 'Close',

	'fourAdditionalDocuments.title': 'Vehicle details',
	'fourAdditionalDocuments.RegistrationDocument.title':
		'Photo of the registration certificate (the front)',
	'fourAdditionalDocuments.RegistrationDocument.description':
		'Take a photo of the registration certificate (the front)',
	'image.locked.RegistrationDocument':
		'Due to personal data protection, downloading registration certificate images has been blocked.',
	'fourAdditionalDocuments.RegistrationDocumentInside.title':
		'Photo of the registration certificate (the reverse)',
	'fourAdditionalDocuments.RegistrationDocumentInside.description':
		'Take a photo of the registration certificate (the reverse)',
	'image.locked.RegistrationDocumentInside':
		'Due to personal data protection, downloading registration certificate images has been blocked.',
	'fourAdditionalDocuments.DniInside.title': ' ',
	'fourAdditionalDocuments.DniInside.description': ' ',
	'image.locked.DniInside': ' ',
	'fourAdditionalDocuments.DniOutside.title': ' ',
	'fourAdditionalDocuments.DniOutside.description': ' ',
	'image.locked.DniOutside': ' ',
	'fourAdditionalDocuments.VehicleDatasheetOutside.title':
		'Photo of the specification sheet (the front)',
	'fourAdditionalDocuments.VehicleDatasheetOutside.description':
		'Take a photo of the specification sheet (the front)',
	'image.locked.VehicleDatasheetInside':
		'Due to personal data protection, downloading vehicle datasheet images has been blocked.',
	'fourAdditionalDocuments.VehicleDatasheetInside.title':
		'Photo of the specification sheet (the reverse)',
	'fourAdditionalDocuments.VehicleDatasheetInside.description':
		'Take a photo of the specification sheet (the reverse)',
	'image.locked.VehicleDatasheetOutside':
		'Due to personal data protection, downloading vehicle datasheet images has been blocked.',
	'fourAdditionalDocuments.DriverLicenseInside.title': ' ',
	'fourAdditionalDocuments.DriverLicenseInside.description': ' ',
	'image.locked.DriverLicenseInside': ' ',
	'fourAdditionalDocuments.DriverLicenseOutside.title': ' ',
	'fourAdditionalDocuments.DriverLicenseOutside.description': ' ',
	'image.locked.DriverLicenseOutside': ' ',
	'completeFourAdditionalDocumentsModal.headline': 'Help',
	'completeFourAdditionalDocumentsModal.description': 'Please add the following information:',
	'fourAdditionalDocuments.RegistrationDocument.headline':
		'Photo of the registration certificate (the front)',
	'fourAdditionalDocuments.RegistrationDocumentInside.headline':
		'Photo of the registration certificate (the reverse)',
	'fourAdditionalDocuments.DniInside.headline': ' ',
	'fourAdditionalDocuments.DniOutside.headline': ' ',
	'fourAdditionalDocuments.VehicleDatasheetOutside.headline':
		'Photo of the specification sheet (the front)',
	'fourAdditionalDocuments.VehicleDatasheetInside.headline':
		'Photo of the specification sheet (the reverse)',
	'fourAdditionalDocuments.DriverLicenseInside.headline': ' ',
	'fourAdditionalDocuments.DriverLicenseOutside.headline': ' ',
	'fourAdditionalDocuments.RegistrationDocument.exampleModalTitle':
		'Photo of the registration certificate (the front) - example',
	'fourAdditionalDocuments.RegistrationDocumentInside.exampleModalTitle':
		'Photo of the registration certificate (the reverse) - example',
	'fourAdditionalDocuments.DniInside.exampleModalTitle': ' ',
	'fourAdditionalDocuments.DniOutside.exampleModalTitle': ' ',
	'fourAdditionalDocuments.VehicleDatasheetOutside.exampleModalTitle':
		'Photo of the specification sheet (the front) - example',
	'fourAdditionalDocuments.VehicleDatasheetInside.exampleModalTitle':
		'Photo of the specification sheet (the reverse) - example',
	'fourAdditionalDocuments.DriverLicenseInside.exampleModalTitle': ' ',
	'fourAdditionalDocuments.DriverLicenseOutside.exampleModalTitle': ' ',

	'feedback.headline.policyCheck': 'Pictures received successfully',
	'feedback.description': '0',
	'feedback.rating.policyCheck':
		'With how many stars would you rank your experience with the app, being 5 the best score?',
	'feedback.yourOpinion': 'Do yo have any comment?',
	'feedback.button.send': 'Submit',
	'waitForAudit.thankYou': 'We appreciate your feedback',
	'waitForAudit.description.damageFound': 'Thank you for trusting in Allianz',
	'thanks.headline.first': 'Thank you!',
	'thanks.paragraph.first': 'Thank you for trusting in Allianz',

	'invalidFile.size.title': 'Incorrect image size',
	'invalidFile.size.description': 'The image size is bigger than the maximum required',
	'invalidFile.extension.title': 'File type is not supported',
	'invalidFile.extension.description':
		'The specified file type is not supported. Supported file types: .jpg, .jpeg, .jfif, .heic, .heif, .png and .bmp',
};

export default messages;
